module.exports = __webpack_public_path__ + "static/media/WW_04.4a0f04f2.jpg";